import MetricsView from "@/components/MetricsView/metricsView.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import { Card } from "@/shadcn/components/ui/card";

type MetricsPageProps = {
  // TODO: add props here
};

const MetricsPage: React.FC<MetricsPageProps> = (props) => {
  return (
    <BasePage currPage="metrics">
      <Card className="flex flex-col w-full h-full rounded-sm dark:bg-background">
        <MetricsView />
      </Card>
    </BasePage>
  );
};

export default MetricsPage;
